import { toast } from "react-toastify";
import { RECONSTRUIDOS_API } from "../views/MainLayout/components/shared/services/reconstruidos";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialReconstruidos = []

export const reconstruidosReducer = (state = initialReconstruidos, action) => {
    switch(action.type){
        case "reconstruidos/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchReconstruidos = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await RECONSTRUIDOS_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'reconstruidos/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}